import React from "react";
import { Grid } from "@material-ui/core";
import {
  ArrayField,
  Datagrid,
  EmailField,
  Labeled,
  Show,
  Tab,
  TabbedShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

import { BackButton } from "../../../components/common/BackButton";
import { ColorField } from "../../../components/common/ColorField";

const ShowActions = (props) => (
  <TopToolbar>
    <BackButton {...props} />
  </TopToolbar>
);

export const AccountShow = (props) => (
  <Show {...props} title="View Account" actions={<ShowActions />}>
    <TabbedShowLayout>
      <Tab label="Contact Info">
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Labeled label="Account Name">
              <TextField source="businessName" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={3}>
            <Labeled label="Display Name">
              <TextField source="displayName" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={3}>
            <Labeled label="Lot No. Prefix">
              <TextField source="lotNumberPrefix" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={2}>
            <ColorField source="color" label="Account Color" />
          </Grid>
          <Grid item xs={12}>
            <Labeled label="Street">
              <TextField source="address.street" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={6}>
            <Labeled label="City">
              <TextField source="address.city" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={6}>
            <Labeled label="State">
              <TextField source="address.state" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={6}>
            <Labeled label="Zip Code">
              <TextField source="address.zipCode" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={6}>
            <Labeled label="Phone">
              <TextField source="phone" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={6}>
            <Labeled label="Fax">
              <TextField source="fax" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={6}>
            <Labeled label="Email">
              <EmailField source="email" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={6}>
            <Labeled label="Website">
              <TextField source="website" />
            </Labeled>
          </Grid>
          <Grid item xs={12}>
            <Labeled label="CONTACTS" fullWidth>
              <ArrayField source="contacts">
                <Datagrid>
                  <TextField source="name" label="Name" />
                  <EmailField source="email" label="Email" />
                  <TextField source="phone" label="Phone" />
                  <TextField source="description" label="Description" />
                </Datagrid>
              </ArrayField>
            </Labeled>
          </Grid>
          <Grid item xs={12}>
            <></>
          </Grid>
        </Grid>
      </Tab>
    </TabbedShowLayout>
  </Show>
);
